"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=1835%3A437))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const Graph = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M23.54 5h-7.09a.5.5 0 0 0 0 1h5.883l-9.157 9.156-.001.002a.386.386 0 0 1-.538 0l-4.074-4.074-.003-.004a1.386 1.386 0 0 0-1.941 0l-.004.004-6.469 6.469a.5.5 0 1 0 .708.707l6.466-6.467a.386.386 0 0 1 .538 0l4.074 4.074.004.004a1.386 1.386 0 0 0 1.94 0l.004-.004 9.16-9.16v5.882a.5.5 0 1 0 1 0V5.5a.5.5 0 0 0-.5-.5"
    fill="currentColor"
  />,
  "Graph",
  { viewBox: "0 0 25 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
